import { Select } from "@/shared/widgets/select";
import { CustomSwitch } from "@/shared/widgets/switch";
import { Card, CardContent } from "@/shared/ui/card";
import { Input } from "@/shared/ui/input";
import { Label } from "@/shared/ui/label";
import { CheckIcon, XIcon } from "lucide-react";
import { useCategoriesData } from "@/features/categories/hooks/useCategoriesData";
import { LearningType } from "@/features/learnings/service/learningService";

interface Props {
    formData: any;
    setFormData: React.Dispatch<React.SetStateAction<any>>;
    validationErrors?: Record<string, string>;
    clearFieldError?: (field: string) => void;
}

export const BasicInfoSection: React.FC<Props> = ({ formData, setFormData, validationErrors = {}, clearFieldError }) => {
    const { data: categoriesData } = useCategoriesData({ type: "LEARNING" });
    const categories = categoriesData?.data || [];
    
    // Filtrar apenas categorias do tipo LEARNING
    const learningCategories = categories.filter((category: any) => category.type === 'LEARNING');
    const categoryOptions = learningCategories.map((category: any) => ({
        value: category.id,
        label: category.name
    }));

    return (
        <Card className="bg-white/[0.03] border-white/[0.06]">
            <CardContent className="pt-6">
                <div className="space-y-6">
                    <div className="space-y-2">
                        <Label htmlFor="name" className="text-white">
                            Título *
                        </Label>
                        <Input
                            id="name"
                            value={formData.name}
                            onChange={(e) => {
                                setFormData({ ...formData, name: e.target.value });
                                clearFieldError?.('name');
                            }}
                            placeholder="Digite o nome do conteúdo"
                            className={`bg-white/[0.03] border-white/[0.06] text-white ${
                                validationErrors.name ? 'border-red-500' : ''
                            }`}
                            required
                        />
                        {validationErrors.name && (
                            <p className="text-red-500 text-sm mt-1">{validationErrors.name}</p>
                        )}
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <div className="space-y-2">
                            <Label htmlFor="type" className="text-white">Tipo *</Label>
                            <Select
                                className="w-full"
                                value={formData.type}
                                onChange={(value: LearningType) =>
                                    setFormData({ ...formData, type: value })
                                }
                                data={[
                                    { value: 'ARTICLE', label: 'Artigo' },
                                    { value: 'VIDEO', label: 'Vídeo' },
                                    { value: 'COURSE', label: 'Curso' },
                                ]}
                            />
                        </div>
                        
                        <div className="space-y-2">
                            <Label htmlFor="category" className="text-white">
                                Categoria *
                            </Label>
                            <Select
                                className="w-full"
                                value={formData.categoryLearning || ''}
                                onChange={(value: string) => {
                                    setFormData({ ...formData, categoryLearning: value });
                                    clearFieldError?.('categoryLearning');
                                }}
                                data={categoryOptions}
                                placeholder="Selecione uma categoria"
                                error={!!validationErrors.categoryLearning}
                                errorMessage={validationErrors.categoryLearning}
                            />
                        </div>
                        
                        <div className="space-y-2">
                            <CustomSwitch
                                id="published"
                                label="Publicado"
                                descriptionOn="O conteúdo será publicado"
                                descriptionOff="O conteúdo não será publicado"
                                iconOn={<CheckIcon className="h-4 w-4 text-green-500" />}
                                iconOff={<XIcon className="h-4 w-4 text-red-500" />}
                                checked={formData.published}
                                onChange={(checked) =>
                                    setFormData({ ...formData, published: checked })
                                }
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
};
